<template>
  <div class="installation-guide" :class="{ 'ac-bg-gray': ac }">
    <header-component
      :is-soon="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />

    <div class="installation-guide-content">
      <h1 v-html="guideInstallation.title"></h1>
      <p v-html="guideInstallation.description"></p>

      <section class="installation_guide_container">
        <div class="selection_container">
          <div class="selection_input" @click="toggleOsSelectionOpened">
            <span v-html="osSelected ? osSelected : 'Selecione o SO'" />
          </div>

          <div
            class="selection_options_container"
            :class="{ opened_options: osSelectionOpened }"
          >
            <label
              v-for="(item, index) in osList"
              :data-selected="item === osSelected"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectOs(item)"
            />
          </div>
        </div>
      </section>

      <div class="layout" v-if="osSelected !== null">
        <div class="tab-container">
          <input
            name="nav"
            type="radio"
            class="about-radio"
            id="qrcode"
            :checked="selectedTab === 'qrcode'"
            @change="handleTabChange('qrcode')"
          />

          <label class="nav" for="qrcode">
            <span> Via QR Code </span>
          </label>
        </div>

        <div class="tab-container">
          <input
            name="nav"
            type="radio"
            class="nav home-radio"
            id="manual"
            :checked="selectedTab === 'manual'"
            @change="handleTabChange('manual')"
          />

          <label class="nav" for="manual">
            <span> Instalação Manual </span>
          </label>
        </div>
      </div>

      <div
        class="welcome_card"
        v-if="osSelected !== null"
        :class="{ 'ac-bg-gray': ac }"
      >
        <div
          v-for="(image, index) in selectedOsImages"
          :key="index"
          :class="{ 'ac-color-yellow': ac }"
        >
          <img v-if="image.type === 'image'" :src="image.source" />

          <div v-if="image.type === 'code'" class="code-wrapper">
            <span class="code-label">Código de ativação</span>

            <div class="code-container">
              <span>{{ isIosSelected ? code : urlEsim }}</span>

              <button v-clipboard:copy="isIosSelected ? code : urlEsim">
                <copy-icon />
              </button>
            </div>
          </div>

          <div v-if="image.type === 'address'" class="code-wrapper">
            <span class="code-label">Endereço SM-DP+</span>

            <div class="code-container">
              <span>{{ address }}</span>

              <button v-clipboard:copy="address">
                <copy-icon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderComponent from "../components/HeaderComponent";
  import CopyIcon from "../components/CopyIcon";
  import { mapState } from "vuex";
  import trackEvent from "@/services/trackEvent";

  export default {
    name: "installation-guide",
    components: {
      HeaderComponent,
      CopyIcon,
    },
    data() {
      return {
        osSelectionOpened: false,
        osSelected: null,
        osList: [],
        selectedTab: "qrcode",
      };
    },
    computed: {
      ...mapState({
        ac: state => state.ac,
        urlEsim: state => state.urlEsim,
        customer: state => state.customer,
        guideInstallation: state => state.config.guideInstallation,
        guideToInstallationImages: state =>
          state.config.guideToInstallationImages,
        config: (state) => state.config,
      }),
      selectedOsImages() {
        if (!this.osSelected) {
          return [];
        }

        return this.guideToInstallationImages[this.osSelected][
          this.selectedTab
        ];
      },
      code() {
        return this.getEsim(2);
      },
      address() {
        return this.getEsim(1);
      },
      isIosSelected() {
        return Boolean(this.osSelected?.toLowerCase().includes("ios"));
      },
    },
    created() {
      this.sendTracker("como ativar esim", 3);
      this.osList = Object.keys(this.guideToInstallationImages);
    },
    methods: {
      returnHome() {
        this.$router.push({ name: "welcome" });
      },
      handleTabChange(tab) {
        this.selectedTab = tab;
        this.sendTracker(
          tab === "qrcode"
            ? "como ativar via qr code"
            : "como ativar via instalacao manual",
        );
      },
      selectOs(value) {
        this.osSelected = value;
        this.osSelectionOpened = false;
        this.sendTracker(`como ativar_${value}`);
      },
      toggleOsSelectionOpened() {
        this.osSelectionOpened = !this.osSelectionOpened;
      },
      getEsim(index) {
        const str = this.urlEsim;
        const urlEsim = str.split("$");
        return urlEsim[index];
      },
      sendTracker(eventLabel, eventAction = 2) {
        trackEvent.track({
          user: {
            login: this.customer.login,
            loginType: this.customer.loginType,
            lineType: this.customer.lineType,
            segment: this.customer.segment,
            subSegment: this.customer.subSegment,
            planCode: this.customer.planCode,
            planName: this.customer.planName,
          },
          channel: trackEvent.getChannel(),
          "event-category": 6,
          "event-label": eventLabel,
          "event-location": "mvp esim",
          "event-value": this.isExOi() ? "oi" : "tim",
          "event-status": "Sucesso",
          "event-action": eventAction,
        });
      },
      isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		}
    },
  };
</script>

<style lang="scss" scoped>
  label,
  a {
    cursor: pointer;
    user-select: none;
    text-decoration: none;
    display: inline-block;
    color: inherit;
    padding: 3px 2px;
  }

  .layout {
    padding: 0 1.5rem;
    width: 100%;
    align-items: center;
    display: flex;
    border-bottom: 1px solid #e5e5e5;
  }

  .tab-container {
    flex: 1;
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"]:checked + label {
    color: #0026d9;
    margin-bottom: 0;
    border-bottom: 4px solid #0026d9;
  }

  label.nav {
    box-sizing: border-box;
    padding: 1.75rem 0;
    margin-bottom: 4px;
    cursor: pointer;
  }

  .installation-guide {
    width: 100%;
    margin-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .welcome_card {
    width: 100%;
    padding: 3rem 0;
    display: flex;
    align-items: center;
    flex-direction: column;

    > div {
      width: 100%;
    }
  }

  .installation_guide_container {
    display: flex;
    width: 100%;
    flex-direction: column;

    > .selection_container {
      box-sizing: border-box;
      padding: 0 1.5rem;
      margin: 1.5rem 0;
      position: relative;

      > .selection_input {
        position: relative;
        padding: 1rem;
        border-radius: 26px;
        font-family: "timsans_regular";
        font-size: 1rem;
        border: 1px solid #b3b3b3;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        cursor: pointer;

        > span {
          opacity: 1 !important;
          color: #000000;
          margin-top: 0 !important;
          max-width: 90%;
          text-align: start;
        }
      }

      > .selection_options_container {
        display: none;
      }

      > .selection_options_container.opened_options {
        box-sizing: border-box;
        position: absolute;
        display: flex;
        top: 100%;
        margin-top: 1rem;
        left: 1.5rem;
        right: 1.5rem;
        box-sizing: border-box;
        overflow-y: scroll;
        overflow-x: hidden;
        flex-direction: column;
        background: #fff;
        border-radius: 16px;
        box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
        z-index: 10;

        > label {
          width: 100%;
          box-sizing: border-box;
          padding: 1.5rem;
          font-family: "timsans_regular";
          font-size: 0.875rem;
          color: #9c9c9c;

          &[data-selected="true"] {
            color: #0026d9;
          }
        }

        > label:hover {
          background-color: #e7e7e7;
        }
      }

      > .selection_input::-ms-expand {
        display: none;
      }

      > .selection_input::after {
        content: "<";
        font: 20px "Consolas", monospace;
        color: #9c9c9c;
        -webkit-transform: rotate(180deg) scaleY(1.2);
        -moz-transform: rotate(270deg) scaleY(1.2);
        -ms-transform: rotate(270deg) scaleY(1.2);
        transform: rotate(270deg) scaleY(1.2);
        right: 1.5rem;
        position: absolute;
        pointer-events: none;
      }
    }
  }

  .installation-guide-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    text-align: center;
    margin-top: 3.375rem;
  }

  .installation-guide-content h1 {
    text-align: center;
    margin: 0;
    font-size: 1.5rem;
    font-weight: 300;
    line-height: 1.33;
    font-family: "timsans_regular";
    padding: 0 1.5rem;
  }

  .installation-guide-content p {
    margin-top: 1.5rem;
    opacity: 0.6;
    font-size: 16px;
    color: #000000;
    font-size: 0.875rem;
    padding: 0 1.5rem;
  }

  .code-wrapper {
    width: 100%;
    margin: 1.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    box-sizing: border-box;
    padding: 0 1.875rem;
  }

  div:has(.code-wrapper) + div:has(.code-wrapper) .code-wrapper {
    margin-top: 0;
  }

  .code-label {
    color: black;
    font-weight: 700;
    line-height: 1.5;
    font-size: 0.75rem;
    font-family: "timsans_regular";
  }

  .code-container {
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    border: 1px dashed #bababa;

    > span {
      flex: 1;
      text-align: left;
      color: black;
      font-size: 0.875rem;
      font-family: "timsans_regular";
      padding: 1.25rem 0.875rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > button {
      display: flex;
      border: 0;
      background: transparent;
      align-items: center;
      justify-content: center;
      padding: 0.375rem 0.875rem;
      border-left: 1px dashed #bababa;
      cursor: pointer;
    }
  }
</style>
